import { ProductLine } from 'pricing-pages-ui-components/constants/ProductLine';
import { ProductLevel } from 'pricing-pages-ui-components/constants/ProductLevel';
import { useGetInferenceForPricingRedirectQuery } from '../../__generated__/chirp/com/hubspot/personalization/rpc/RecommendationAppRpc.hooks';
import { useAppSelector } from '../reducers';
import { currentSuiteApiNamesForProductLevelSelector, productSelector } from '../selectors/ProductsSelectors';
import { isValidPaidProductLevel, isValidProductLine } from '../v2/utils/typeguards';
import { useGlobalLoading } from './loadingHooks';
export const useRecommendedProduct = () => {
  const queryResult = useGetInferenceForPricingRedirectQuery();
  const {
    data,
    loading
  } = queryResult;
  return {
    recommendationResponse: data,
    loading
  };
};
export const useIsRecommendedStarterCustomerPlatform = () => {
  const {
    recommendationResponse
  } = useRecommendedProduct();
  return (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) === 'CRM_SUITE' && (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier) === ProductLevel.STARTER;
};
export const useIsRecommendedSalesHubPro = () => {
  const {
    recommendationResponse
  } = useRecommendedProduct();
  return (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub) === ProductLine.SALES && (recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier) === ProductLevel.PROFESSIONAL;
};
export const useGetRecommendedApiNames = () => {
  const isAppReady = useGlobalLoading();
  const {
    recommendationResponse,
    loading
  } = useRecommendedProduct();
  const hub = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub;
  const tier = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.tier;
  return useAppSelector(state => {
    if (!isAppReady || loading) {
      return {
        apiNames: undefined,
        loading: true
      };
    }
    if (hub === 'CRM_SUITE') {
      const suiteApiNames = isValidPaidProductLevel(tier) && currentSuiteApiNamesForProductLevelSelector(state, {
        productLevel: tier
      });
      return {
        apiNames: suiteApiNames,
        loading: false
      };
    } else if (isValidProductLine(hub) && isValidPaidProductLevel(tier)) {
      const product = productSelector(state, {
        productLevel: tier,
        productLine: hub
      });
      const apiName = product && product.apiName;
      const apiNames = apiName ? [apiName] : undefined;
      return {
        apiNames,
        loading: false
      };
    }
    return {
      apiNames: undefined,
      loading: false
    };
  });
};
const ProductLineToRouteMap = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  OPERATIONS: 'data',
  CMS: 'content',
  CRM_SUITE: 'suite'
};
const isValidProductLineKey = hub => {
  return hub !== undefined && typeof hub === 'string' && hub in ProductLineToRouteMap;
};
export const useRecommendedRouting = () => {
  const {
    recommendationResponse,
    loading
  } = useRecommendedProduct();
  const recommendedProductLine = recommendationResponse === null || recommendationResponse === void 0 ? void 0 : recommendationResponse.hub;
  const recommendedRoute = isValidProductLineKey(recommendedProductLine) ? ProductLineToRouteMap[recommendedProductLine] : 'marketing';
  return {
    recommendedRoute,
    loading
  };
};